export const environment = {
    production: false,
    baseUrlBackend: 'http://192.168.1.52:8000',
    baseUrlBackendPrincipal: 'http://192.168.1.52:8000/api',
    webUrl: 'http://192.168.1.52:4200'
};
  